import { MODALS } from "@kiwicom/frontend-common/consts/modals"

export const MMB1_MIGRATED_MODALS = Object.freeze({
  INVOICES: MODALS.INVOICES,
  REQUESTS_REFUNDS: MODALS.REFUND_STATUSES,
  REFUND_DETAILS: MODALS.REFUND_DETAILS,
  OOP_KIWI_OFFER: MODALS.OOP_KIWI_OFFER,
  ALTERNATIVE_METHOD_OFFER: MODALS.ALTERNATIVE_METHOD_OFFER,
  PROACTIVE_REFUND_OFFER: MODALS.PROACTIVE_REFUND_OFFER,
  CHECK_IN_HEALTH_DECLARATION: MODALS.CHECK_IN_HEALTH_DECLARATION,
  CHECK_IN_DOCUMENTS: MODALS.CHECK_IN_DOCUMENTS,
  PAYMENT: MODALS.PAYMENT,
  DISRUPTION_PROTECTION_UPSELL: MODALS.DISRUPTION_PROTECTION_UPSELL,
  SCHEDULE_CHANGE: MODALS.SCHEDULE_CHANGE,
  BAGGAGE: MODALS.BAGS,
  SEATING: MODALS.SEATING,
  NON_PROCESSED_BOOKING: MODALS.PENDING_REFUNDS,
  PASSENGER_DETAILS: MODALS.PASSENGER_DETAILS,
  DOCUMENT_VERIFICATION: MODALS.DOCUMENT_VERIFICATION,
  ITINERARY_DETAILS: MODALS.ITINERARY_DETAILS,
  INSTANT_CREDIT: MODALS.INSTANT_CREDIT,
  ASSISTED_REFUND: MODALS.ASSISTED_REFUND,
  FARE_TYPE_REFUND: MODALS.FARE_TYPE_REFUND,
  INSURANCE: MODALS.INSURANCE,
  UNCONFIRMED_BOOKING_CANCELLATION: MODALS.BOOKING_CANCELLATION,
  UNCONFIRMED_BOOKING_CANCELLATION_REQUEST: MODALS.BOOKING_CANCELLATION_REQUEST,
  MEDICAL: MODALS.MEDICAL,
  DEATH: MODALS.DEATH,
  ITINERARY_CHANGE: MODALS.CHANGE_FLIGHTS,
  AUTOMATIC_VOID: MODALS.AUTOMATIC_VOID,
  EXPENSE_REFUND: MODALS.EXPENSE_REFUND,
  DISRUPTION_REFUND: MODALS.DISRUPTION_REFUND,
  INVOLUNTARY_ASSISTED_REFUND: MODALS.INVOLUNTARY_ASSISTED_REFUND,
  SPECIAL_ASSISTANCE: MODALS.SPECIAL_ASSISTANCE,
  REFUND_OPTIONS: MODALS.REFUND,
})

export const REDIRECT_TO_SHOPPING_BASKET_FAILURE = "REDIRECT_TO_SHOPPING_BASKET_FAILURE"
export const REDIRECT_TO_SEATING_FAILURE = "REDIRECT_TO_SEATING_FAILURE"

export type MMB1MigratedModals = typeof MMB1_MIGRATED_MODALS[keyof typeof MMB1_MIGRATED_MODALS]

export type MMB2FeatureRoute = "invoices" | string // for dynamic requests/refunds/[requestId]

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
export type DynamicRouteValues = {
  [key: string]: string | number
}

export type MMB2Redirect = (
  modalName: MMB1MigratedModals,
  dynamicRouteValues?: DynamicRouteValues,
  additionalTrackingProps?: Record<string, string | number>,
) => void
